<script>
import SectionAddress from './components/SectionAddress/SectionAddress'
import SectionOrder from './components/SectionOrder/SectionOrder'
import ViewBase from '@/components/ViewBase/ViewBase'
export default {
  name: 'ViewOrder',
  extends: ViewBase,
  components: {
    SectionAddress,
    SectionOrder
  },
  beforeMount () {
    this.api(this.$route.path)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ViewOrder/ViewOrder.vue